export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(reg => {
          reg.onupdatefound = () => {
            const sw = reg.installing;
            if (!sw) return;
            sw.onstatechange = () => {
              if (sw.state === 'installed' && navigator.serviceWorker.controller) {
                // Nova versão disponível — notificar após 3s
                setTimeout(() => {
                  if (window.confirm('Nova versão disponível. Atualizar agora?')) {
                    sw.postMessage({ type: 'SKIP_WAITING' });
                    window.location.reload();
                  }
                }, 3000);
              }
            };
          };
        })
        .catch(err => console.warn('SW:', err));
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(reg => reg.unregister())
      .catch(err => console.error(err));
  }
}
